<template>
  <v-container pa-0>
    <v-btn
      v-if="!btnValidDisabled"
      icon
      class="basket-btn"
      @click="dialog = true"
    >
      <v-icon color="black">
        mdi-basket
      </v-icon>
    </v-btn>

    <tabs
      v-model="current"
      :headers="headers"
      class="mt-n2"
    >
      <v-card
        v-for="(list, i) in listproducts"
        :key="i"
        :slot="`tab_${i}`"
        class="product-list"
        :class="{'offline': offline}"
      >
        <product-key
          v-for="(product, j) in list.products"
          :key="`${i}_${j}`"
          :product="product"
          @add="add(i, j)"
        />
      </v-card>

      <ecocup
        v-if="useEcocup"
        :slot="`tab_${headers.length - 1}`"
      />
    </tabs>

    <!-- *********************************
    ********** PRIX LIBRE MODAL **********
    ********************************** -->
    <keyboard-dialog
      v-model="showFreePrice"
      :screen-title="$t('title.article_price')"
      use-default-screen
      auto-close
      :title="currentIndexes ? currentIndexes.title : ''"
      @close="currentIndexes = null"
      @valid="setProductPrice"
    />

    <!-- **********************************
    ********** LISTE DE PRODUITS **********
    *********************************** -->
    <product-list
      v-if="dialog"
      :dialog="dialog"
      @hide="dialog = false"
      @suppr="deleteFromList"
    />

    <!-- *******************************
    ********** BOTTOM BUTTONS **********
    ******************************** -->
    <bottom-action
      btn-cancel
      btn-valid
      :btn-valid-disabled="btnValidDisabled"
      :use-listener="false"
      @cancel="cancel"
      @del="del"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { LimitTransactionHard } from '@/modules/Enums'
import { LogoImages } from '@/modules/Images'

import Ecocup from '../ecocup/Ecocup'
import KeyboardDialog from '../../modal/KeyboardDialog'
import ProductList from './ProductList'
import ProductKey from './ProductKey'
import { $alert } from '@/modules/Utils'
import Tabs from '@/components/Tabs'

export default {
  name: 'ProductKeyboard',

  components: {
    ProductList,
    Tabs,
    Ecocup,
    KeyboardDialog,
    ProductKey
  },

  data () {
    return {
      LogoImages,
      save: [],
      current: 0,
      //
      showFreePrice: false,
      currentIndexes: null,
      dialog: false,
    }
  },

  computed: {
    btnValidDisabled () {
      return this.$store.getters.totalNumberOfConsignesAndProducts === 0
    },
    offline () { return this.$store.state.offline },
    listproducts () { return this.$store.state.listproducts },
    useEcocup () { return this.$store.state.consignes.length > 0 },
    nbTransactions () { return this.$store.getters.totalTransactions },
    total: {
      get () { return this.$store.state.amount },
      set (val) { this.$store.commit('amount', val) }
    },
    headers () {
      const res = this.listproducts.map(cat => cat.name)
      if (this.useEcocup) res.push('ecocup')
      return res
    }
  },

  methods: {
    add (i, j) {
      if (this.listproducts[i].products[j].freeprice) {
        this.currentIndexes = { i: i, j: j, title: this.listproducts[i].products[j].label }
        this.showFreePrice = true
      } else {
        let newTotal = this.total + this.listproducts[i].products[j].price

        // Limitation du montant à 10 000€ et non négatif
        if (newTotal < 10000000) {
          this.total = newTotal
          this.$store.dispatch('addProduct', { i: i, j: j })
          this.save.unshift({ i: i, j: j })
        }
      }
    },
    cancel () {
      this.save = []
      this.total = 0
      this.$store.dispatch('resetProducts')
    },
    del () {
      if (this.save.length > 0) {
        let index = this.save[0]
        let newTotal = this.total - this.listproducts[index.i].products[index.j].price
        if (newTotal >= 0) {
          this.total = newTotal
          this.$store.dispatch('delProduct', this.save[0])
          this.save.shift()
        } else {
          this.cancel()
        }
      }
    },
    valid () {
      if (!this.btnValidDisabled) {
        if (this.nbTransactions >= LimitTransactionHard) {
          $alert(this.$i18n.t('error.offline_trx_max'))
        } else {
          this.$router.replace({ name: 'action-choice', params: { fromAchat: true } })
        }
      }
    },
    //
    setProductPrice (price) {
      this.$store.dispatch('setProductPrice', { ...this.currentIndexes, price: price })
      this.$store.dispatch('addProduct', { i: this.currentIndexes.i, j: this.currentIndexes.j })
      this.save.unshift({ i: this.currentIndexes.i, j: this.currentIndexes.j })
      this.total += price
      this.currentIndexes = null
    },
    deleteFromList (i, j) {
      const indexes = [];
      this.save.forEach((element, index) => {
        if (element.i === i && element.j === j) {
          indexes.push(index)
        }
      })
      indexes.forEach(index => {
        this.save.splice(index, 1)
      })
    }
  }
}
</script>
